import { useState } from 'react';
import apiClient from '../../utils/api';

const REPORT_CATEGORIES = [
  { value: 'fraud', label: 'Fraud or scam' },
  { value: 'suspicious_listing', label: 'Suspicious listing' },
  { value: 'harassment', label: 'Harassment or abuse' },
  { value: 'spam', label: 'Spam' },
  { value: 'other', label: 'Other' },
];

const ReportConversationModal = ({ conversation, onClose, addToast }) => {
  const [category, setCategory] = useState('suspicious_listing');
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);

  if (!conversation?.id) return null;

  const submit = async () => {
    const details = reason.trim();
    if (!details) {
      addToast?.('Please describe what happened.', 'error');
      return;
    }
    setBusy(true);
    try {
      await apiClient.reportListingConversation(conversation.id, { category, reason: details });
      addToast?.('Report submitted. Our team will review this conversation.', 'success');
      onClose?.();
    } catch (err) {
      addToast?.(err.message || 'Could not submit report.', 'error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-overlay active" onClick={(e) => e.target === e.currentTarget && !busy && onClose?.()}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()} role="dialog" aria-labelledby="report-conversation-title">
        <div className="modal-header">
          <h2 id="report-conversation-title">Report conversation</h2>
          <button type="button" className="modal-close" disabled={busy} onClick={onClose} aria-label="Close">&times;</button>
        </div>
        <div className="modal-body">
          <p style={{ color: 'var(--text-light)', fontSize: '0.9rem', marginBottom: '1rem', lineHeight: 1.5 }}>
            Flag fraud, suspicious listings, or abuse. Reports go to CoOwn admins — include as much detail as you can.
          </p>
          {conversation.propertyTitle && (
            <p style={{ fontSize: '0.85rem', marginBottom: '1rem', padding: '0.65rem 0.75rem', background: 'var(--bg)', borderRadius: 8 }}>
              <strong>Listing:</strong> {conversation.propertyTitle}
            </p>
          )}
          <div className="form-group">
            <label>Category</label>
            <select value={category} onChange={(e) => setCategory(e.target.value)} style={{ width: '100%', padding: '0.6rem', borderRadius: 8, border: '1px solid var(--border)' }}>
              {REPORT_CATEGORIES.map((c) => (
                <option key={c.value} value={c.value}>{c.label}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>What happened?</label>
            <textarea
              rows={4}
              value={reason}
              disabled={busy}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Describe the issue — misleading listing, payment off-platform, harassment, etc."
              style={{ width: '100%', padding: '0.6rem', borderRadius: 8, border: '1px solid var(--border)', fontFamily: 'inherit' }}
            />
          </div>
          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <button type="button" className="btn btn-outline" disabled={busy} onClick={onClose}>Cancel</button>
            <button type="button" className="btn btn-sm" style={{ background: 'var(--danger)', color: '#fff' }} disabled={busy} onClick={submit}>
              {busy ? 'Submitting…' : 'Submit report'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportConversationModal;
